import { createFileRoute } from '@tanstack/react-router';
import { AppBundle } from '@/utils/app-bundles';
import { JourneysDataIndexIndexHandoff } from '@/pages/workspaces/data-index/routing';
import { LastWorkspaceResolver } from './-route-layouts';

/**
 * `appBundle` belongs on this twin and not the migrated one: this URL keeps
 * the `journeys` segment, so the resolver can rebuild the target from the
 * bundle prefix when the `/workspaces/last` sentinel needs resolving.
 */
export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/data-index/')({
  component: () => (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <JourneysDataIndexIndexHandoff />
    </LastWorkspaceResolver>
  ),
});
